import { useQuery } from '@tanstack/react-query'

import { fetchMatchmakingSuggestions } from './api'

export const matchmakingSuggestionsKey = (
  digitalProductId: string | number,
  perGroup?: number
) => ['matchmaking-suggestions', String(digitalProductId), perGroup ?? 'default']

/**
 * As sugestões são calculadas na leitura, sem cache no servidor — então revogar
 * consentimento vale já na próxima busca. `refetchOnWindowFocus` fica desligado
 * para a ordem não trocar embaixo do participante enquanto ele lê a lista.
 *
 * `enabled` existe porque o bloco da home não busca ao carregar: o cálculo é o
 * mais caro do módulo e a home é a tela mais visitada, então quem abre a home e
 * não olha as conexões não paga por elas. A página dedicada busca ao abrir, e
 * por isso o padrão é ligado — desligar é escolha de quem chama.
 */
export const useMatchmakingSuggestionsQuery = (
  digitalProductId: string | number | null | undefined,
  perGroup?: number,
  { enabled = true }: { enabled?: boolean } = {}
) =>
  useQuery({
    queryKey: matchmakingSuggestionsKey(digitalProductId ?? '', perGroup),
    queryFn: () =>
      fetchMatchmakingSuggestions(digitalProductId as string | number, perGroup),
    enabled: enabled && !!digitalProductId,
    refetchOnWindowFocus: false
  })
